"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PropTypes = require("prop-types");
var React = require("react");
var scroll_to_item_1 = require("../shared/scroll_to_item");
var classNames = require("classnames");
var DOWN_ARROW = 40;
var UP_ARROW = 38;
var ENTER = 13;
var ScrollableList = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollableList, _super);
    function ScrollableList(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = _this.onChange.bind(_this);
        _this.handleArrows = _this.handleArrows.bind(_this);
        _this.state = {
            focused: null,
        };
        return _this;
    }
    ScrollableList.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.items !== nextProps.items) {
            this.setState({ focused: null });
        }
    };
    ScrollableList.prototype.componentDidUpdate = function () {
        var focusedItem = this.refs["item-" + this.state.focused];
        var list = this.refs.list;
        new scroll_to_item_1.default(focusedItem, list).scrollToItem();
    };
    ScrollableList.prototype.onChange = function (e) {
        if (this.props.changeEvent) {
            this.props.changeEvent(e);
        }
    };
    ScrollableList.prototype.handleArrows = function (e) {
        if (e.keyCode === DOWN_ARROW) {
            this.focusNext();
        }
        else if (e.keyCode === UP_ARROW) {
            this.focusPrevious();
        }
        else if (e.keyCode === ENTER && this.props.onEnter) {
            this.props.onEnter(e);
        }
    };
    // used by ProductSearchForm in handleSubmit()
    ScrollableList.prototype.focusedItem = function () {
        return this.props.items[this.currentFocus()];
    };
    ScrollableList.prototype.currentFocus = function () {
        var currentFocus = this.state.focused;
        if (currentFocus === null) {
            currentFocus = -1;
        }
        return currentFocus;
    };
    ScrollableList.prototype.focusNext = function () {
        var currentFocus = this.currentFocus();
        if (currentFocus < this.props.items.length - 1) {
            this.setState({ focused: currentFocus + 1 });
        }
    };
    ScrollableList.prototype.focusPrevious = function () {
        var currentFocus = this.currentFocus();
        if (currentFocus > 0) {
            this.setState({ focused: currentFocus - 1 });
        }
    };
    ScrollableList.prototype.items = function () {
        var _this = this;
        return this.props.items.map(function (result, index) { return (React.createElement("li", { key: result.id, ref: "item-" + index, className: classNames('product-search-form__row', {
                'product-search-form__item--active': _this.state.focused === index,
            }) }, _this.props.renderItem(result))); });
    };
    Object.defineProperty(ScrollableList.prototype, "shouldShowItems", {
        get: function () {
            return this.props.items.length && !this.props.hideItems;
        },
        enumerable: true,
        configurable: true
    });
    ScrollableList.prototype.renderItems = function () {
        if (!this.shouldShowItems) {
            return null;
        }
        return (React.createElement("ul", { className: "product-search-form__rows", ref: "list" }, this.items()));
    };
    ScrollableList.prototype.render = function () {
        var inputClasses = classNames('product-search-form__input', { 'product-search-form__input--with-results': this.shouldShowItems });
        return (React.createElement("div", { className: "product-search-form", "data-product-search-form": true },
            React.createElement("input", { className: inputClasses, autoComplete: this.props.autoComplete, autoFocus: this.props.autoFocus, name: this.props.name, placeholder: this.props.placeholder, type: this.props.type, ref: "input", onChange: this.onChange, onKeyDown: this.handleArrows, value: this.props.inputValue }),
            this.renderItems()));
    };
    return ScrollableList;
}(React.Component));
ScrollableList.propTypes = {
    renderItem: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    hideItems: PropTypes.bool,
    changeEvent: PropTypes.func,
    onEnter: PropTypes.func,
    listClass: PropTypes.string,
    autoComplete: PropTypes.string,
    autoFocus: PropTypes.string,
    className: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    inputValue: PropTypes.string,
};
ScrollableList.defaultProps = {
    hideItems: false,
};
exports.default = ScrollableList;
//# sourceMappingURL=scrollable_list.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/product_search_form/scrollable_list.js
// module id = 25RE
// module chunks = 20 21